import React from "react";
import { Alert } from "react-bootstrap";
import LoadingSpinner from "./LoadingSpinner";

interface LoaderErrorProps {
  loading: boolean;
  error?: string | null | any;
  children: React.ReactNode;
}

const LoaderErrorWrapper: React.FC<LoaderErrorProps> = ({
  loading,
  error,
  children,
}) => {
  const themeColor = "#3969E7"; // Primary color from tableStyles (same as ActionButton)

  if (loading) {
    return (
      <LoadingSpinner themeColor={themeColor} />
    );
  }

  if (error) {
    // Extract error message from error object or string
    let errorMessage: string;
    if (typeof error === "string") {
      errorMessage = error;
    } else if (error?.error) {
      errorMessage = error.error;
    } else if (error?.message) {
      errorMessage = error.message;
    } else if (error?.response?.data?.error) {
      errorMessage = error.response.data.error;
    } else if (error?.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else {
      errorMessage = "An error occurred";
    }
    
    return (
      <Alert variant="danger" className="my-3">
        <strong>Error:</strong> {errorMessage}
      </Alert>
    );
  }

  return <>{children}</>;
};

export default LoaderErrorWrapper;
